// extracted by mini-css-extract-plugin
export var phonePopupOverlay = "PhonePopup-module--phonePopupOverlay--8roYm";
export var phonePopupOverlayIn = "PhonePopup-module--phonePopupOverlayIn--KGKDl";
export var phonePopupSheet = "PhonePopup-module--phonePopupSheet--GIcu5";
export var phonePopupSheetIn = "PhonePopup-module--phonePopupSheetIn--Ey6OV";
export var phonePopupButton = "PhonePopup-module--phonePopupButton--s2wis";
export var phonePopupTextButton = "PhonePopup-module--phonePopupTextButton--GwWIF";
export var phonePopupCancelButton = "PhonePopup-module--phonePopupCancelButton--1A8oa";